<div class="el-shell">
  <div class="container">

    <!-- HEADER -->
    <div class="el-header">
      <div class="el-title-block">
        <div class="icon-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13" rx="1"/>
            <path d="M16 8h4l3 4v4h-7V8z"/>
            <circle cx="5.5" cy="18.5" r="2.5"/>
            <circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
        </div>
        <div class="title-text">
          <h1>Logística</h1>
          <p>Pedidos conferidos aguardando confirmação de envio.</p>
        </div>
      </div>

      <!-- Badge da empresa filtrada -->
      <div class="badge-empresa-tela"
           [style.background]="empresaState.corClaraPorCodEmp(empresaState.selecionada, 0.78)"
           [style.border-color]="empresaState.corPorCodEmp(empresaState.selecionada)">
        <span class="badge-empresa-dot" [style.background]="empresaState.corPorCodEmp(empresaState.selecionada)"></span>
        <span class="badge-empresa-texto">
          Empresa {{ empresaState.selecionada }}<ng-container *ngIf="nomeEmpresaAtual"> — {{ nomeEmpresaAtual }}</ng-container>
        </span>
      </div>
    </div>

    <!-- ERROS -->
    <div *ngIf="erroConfirmar" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ erroConfirmar }}
    </div>
    <div *ngIf="erro" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ erro }}
    </div>

    <!-- LISTA -->
    <div class="content-card">
      <div *ngIf="carregando" class="loading-state">
        <app-loading-indicator></app-loading-indicator>
        <span>Buscando pedidos para expedição...</span>
      </div>

      <div *ngIf="!carregando && pedidos.length === 0 && !erro" class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <path d="M16 8h4l3 4v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        <h3>Fila Limpa!</h3>
        <p>Não há nenhum pedido aguardando expedição no momento.</p>
      </div>

      <div class="pedidos-grid" *ngIf="!carregando && pedidos.length > 0">
        <div class="pedido-card" *ngFor="let p of pedidos">

          <div class="card-header">
            <span class="nunota-badge">#{{ p.nunota }}</span>
            <div class="badges-right">
              <span class="badge badge-imediato" *ngIf="p.imediato === 'S' || p.imediato === 'Sim'">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
                Imediato
              </span>
              <span [ngClass]="prioridadeClass(p.prioridade)" [class.alta]="p.prioridade === 'Alta' || p.prioridade === 'S'">
                {{ (p.prioridade === 'S' ? 'Alta' : p.prioridade) || 'Normal' }}
              </span>
            </div>
          </div>

          <div class="card-body">
            <h3 class="cliente-nome">{{ p.nomeCliente }}</h3>

            <!-- Prefixo -->
            <p *ngIf="p.prefixo" class="card-info-row card-prefixo-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19.5 2.5S18 2 17 2l-3.5 3.5L5 4.2l-1.4 1.4 6.6 2.8-3 3-2.8-.7-1.4 1.4 4.6 2.4 2.4 4.6 1.4-1.4-.7-2.8 3-3z"/>
              </svg>
              <span class="card-info-label">Prefixo:</span>
              <span class="card-prefixo-badge">{{ p.prefixo }}</span>
            </p>

            <!-- TAG (definida na Separação) -->
            <p *ngIf="p.numTag" class="card-info-row card-tag-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
              <span class="card-info-label">TAG:</span>
              <span class="card-tag-badge">{{ p.numTag }}</span>
            </p>

            <!-- Vendedor -->
            <p class="card-info-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
              <span class="card-info-label">Vendedor:</span> {{ p.vendedor || '—' }}
            </p>

            <!-- Conferente -->
            <p *ngIf="p.confNome" class="card-info-row card-conf-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 11 12 14 22 4"/>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
              </svg>
              <span class="card-info-label">Conferente:</span> {{ p.confNome }}
            </p>

            <!-- Fim conferência -->
            <p *ngIf="p.dataFimConf" class="card-info-row card-data-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              <span class="card-info-label">Conf.:</span> {{ p.dataFimConf }}
            </p>

            <!-- Total itens -->
            <p class="card-info-row card-itens-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
                <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
                <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
              </svg>
              <span>{{ p.totalItens }} {{ p.totalItens === 1 ? 'item' : 'itens' }}</span>
            </p>
          </div>

          <div class="card-footer">
            <button class="btn-confirmar" (click)="abrirModal(p)">
              <span>Confirmar Envio</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
            <button type="button"
                class="btn-estornar"
                title="Estornar pedido para Conferência"
                (click)="solicitarEstornar($event, p)"
                [disabled]="estornandoNunota === p.nunota">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
              <span>Estornar</span>
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── MODAL: Confirmar Estorno para CONFERENCIA ────────────────────────── -->
<div class="el-modal-overlay" *ngIf="confirmandoEstorno" (click)="cancelarEstornar()">
  <div class="el-modal" (click)="$event.stopPropagation()">

    <div class="el-modal-header">
      <div class="el-modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
      </div>
      <div>
        <h2>Estornar Pedido para Conferência</h2>
        <p>Pedido #{{ confirmandoEstorno.nunota }} — {{ confirmandoEstorno.nomeCliente }}</p>
      </div>
      <button class="el-modal-close" (click)="cancelarEstornar()" [disabled]="estornandoNunota !== null">✕</button>
    </div>

    <div class="el-modal-body">
      <p class="el-modal-pergunta">
        O pedido voltará para a fila de Logística de Conferência. O registro de envio já feito neste
        pedido será removido — será preciso confirmar o envio novamente. A conferência já feita não é afetada.
      </p>

      <div *ngIf="erroEstornar" class="alert alert-danger" style="margin-bottom:12px">
        {{ erroEstornar }}
      </div>

      <div class="el-modal-opcoes">
        <button class="el-modal-btn el-modal-btn-secondary" (click)="cancelarEstornar()" [disabled]="estornandoNunota !== null">
          <div class="el-modal-btn-text"><strong>Cancelar</strong></div>
        </button>
        <button class="el-modal-btn el-modal-btn-danger" (click)="confirmarEstornar()" [disabled]="estornandoNunota !== null">
          <div class="el-modal-btn-text">
            <strong>{{ estornandoNunota === null ? 'Confirmar Estorno' : 'Aguarde...' }}</strong>
          </div>
        </button>
      </div>
    </div>

  </div>
</div>

<!-- ── MODAL CONFIRMAR ENVIO ─────────────────────────────────────────────── -->
<div class="el-modal-overlay" *ngIf="modalAberto" (click)="fecharModal()">
  <div class="el-modal" (click)="$event.stopPropagation()">

    <div class="el-modal-header">
      <div class="el-modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="1"/>
          <path d="M16 8h4l3 4v4h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <div>
        <h2>Pedido #{{ pedidoModal?.nunota }}</h2>
        <p>{{ pedidoModal?.nomeCliente }}</p>
      </div>
      <button class="el-modal-close" (click)="fecharModal()" [disabled]="confirmando">✕</button>
    </div>

    <div class="el-modal-body">
      <p class="el-modal-pergunta">O que deseja fazer com este pedido?</p>

      <div *ngIf="erroConfirmar" class="alert alert-danger" style="margin-bottom:12px">
        {{ erroConfirmar }}
      </div>

      <div class="el-modal-opcoes">
        <!-- Visualizar Itens -->
        <button class="el-modal-btn el-modal-btn-secondary" (click)="onVisualizarItens()" [disabled]="confirmando">
          <div class="el-modal-btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
              <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
              <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
            </svg>
          </div>
          <div class="el-modal-btn-text">
            <strong>Visualizar Itens</strong>
            <span>Ver a lista de produtos do pedido</span>
          </div>
        </button>

        <!-- Confirmar Envio -->
        <button class="el-modal-btn el-modal-btn-primary" (click)="onConfirmarEnvio()" [disabled]="confirmando">
          <div class="el-modal-btn-icon">
            <svg *ngIf="!confirmando" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13" rx="1"/>
              <path d="M16 8h4l3 4v4h-7V8z"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
            <app-loading-indicator *ngIf="confirmando" size="inline"></app-loading-indicator>
          </div>
          <div class="el-modal-btn-text">
            <strong>{{ confirmando ? 'Confirmando...' : 'Confirmar Envio' }}</strong>
            <span>Marcar pedido como Finalizado</span>
          </div>
        </button>
      </div>
    </div>

  </div>
</div>
